import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { JobDetailsContainerStyled } from '../ClientCreatedJobDetails/TechnicianJob/style';

type Props = {
  additionalInfo: {
    title: string;
    value: string;
  }[];
};

const AdditionalRequirement = ({ additionalInfo }: Props) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        ADDITIONAL REQUIREMENT
      </Typography>
      <VerticalSpaceStyled>
        {additionalInfo.map((data, index) => (
          <InfoRowStyled key={index} className="jobInformation">
            <Typography className="title">{data.title} : </Typography>
            <Typography className="value"> {data.value}</Typography>
          </InfoRowStyled>
        ))}
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};

export default AdditionalRequirement;

// import { Typography } from '../../../designComponents';
// import {
//   InfoRowStyled,
//   VerticalSpaceStyled,
// } from '../../../style/reusableStyle';
// import { JobDetailsContainerStyled } from './style';

// type Props = {
//   additionalInfo: {
//     title: string;
//     value: string;
//   }[];
// };

// const AdditionalRequirement = ({ additionalInfo }: Props) => {
//   return (
//     <JobDetailsContainerStyled>
//       <Typography
//         variant="normal"
//         strong
//         fontColor="secondary"
//         className="section-title"
//       >
//         ADDITIONAL REQUIREMENT
//       </Typography>
//       <VerticalSpaceStyled>
//         {additionalInfo.map((data, index) => (
//           <InfoRowStyled key={index} className="jobInformation">
//             <Typography className="title">{data.title} : </Typography>
//             <Typography className="value"> {data.value}</Typography>
//           </InfoRowStyled>
//         ))}
//       </VerticalSpaceStyled>
//     </JobDetailsContainerStyled>
//   );
// };

// export default AdditionalRequirement;
